import React from 'react'
import { useContentful, getVariantContent } from '@pcln/contentful-components'
import { useFeature } from '@pcln/feature-components'
import GenericBanner from '../../GenericBanner'
import MARKETING_TOUT from '../../../constants/promotions/marketing-tout'
import MerchModuleWrapper from '../../MerchModuleWrapper'
import useSeti from '../../CustomHooks/useSeti'

export default function MarketingTout() {
  const contentfulEnabled = useFeature('siteExperience.contentfulEnabled', true)
  const marketingTout: any = useContentful('marketingTout')

  const isContentfulEnabledAndHasContent =
    contentfulEnabled && marketingTout != null

  const setiName = useSeti(
    marketingTout?.experimentName,
    marketingTout?.experimentName !== undefined
  )

  const marketingToutData = marketingTout?.experimentName
    ? getVariantContent(setiName, marketingTout)
    : marketingTout

  return isContentfulEnabledAndHasContent ? (
    <MerchModuleWrapper {...marketingToutData} />
  ) : (
    <GenericBanner content={MARKETING_TOUT} />
  )
}
